import { VALIDATION_MESSAGES } from '@/constants/validation';
import { bool, object, string } from 'yup';

export type LoginFormData = {
	email: string;
	password: string;
	rememberMe?: boolean;
	errorMessage?: string;
};

export const loginSchema = object({
	email: string()
		.trim()
		.email(VALIDATION_MESSAGES.email)
		.required('Please enter your username'),
	password: string().trim().required('Please enter password'),
	rememberMe: bool(),
});

export const loginInitialValues = {
	email: '',
	password: '',
	rememberMe: false,
};
